'use strict';

angular.module('licensure.services')
    .factory('MergeFields', ['$http', '$q', function ($http, $q) {
        return {
            get: function (code) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/MergeFields', {
                        params: {
                            code: code
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;